import { Component } from '@angular/core'
import { ConfirmedSessionsResponse, User } from '@app/core/_models'
import { ConfirmedSessionsService, UtilsService } from '@app/core/_services'
import { BookedSessionTileComponent } from '@app/routes/dashboard/components/booked-session-tile/booked-session-tile.component'
import { Subject, takeUntil } from 'rxjs'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faCrystalBall, faScroll } from '@fortawesome/pro-solid-svg-icons'
import { UserDateFormattingService } from '@app/core/_services/user-date-formatting.service'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { ButtonModule } from 'primeng/button'

interface MySessionList {
    dateLabel: string
    sessions: ConfirmedSessionsResponse[]
}

@Component({
    selector: 'app-rp-schedule',
    imports: [BookedSessionTileComponent, FontAwesomeModule, ScrollPanelModule, ButtonModule],
    templateUrl: './rp-schedule.component.html',
    styleUrl: './rp-schedule.component.scss',
})
export class RpScheduleComponent {
    private ngUnsubscribe: Subject<any> = new Subject<any>()
    public confirmedSessions: ConfirmedSessionsResponse[]
    faCrystalBall = faCrystalBall
    faScroll = faScroll

    public showUpcoming = true

    public sessionList: MySessionList[] = []
    public sessionListPast: MySessionList[] = []
    public currentUser: User

    constructor(
        private userDateFormattingService: UserDateFormattingService,
        private utilsService: UtilsService,
        private confirmedSessionsService: ConfirmedSessionsService,
    ) {}

    ngOnInit() {
        this.confirmedSessionsService.confirmedSessionsSubject
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((confirmedSessions) => {
                this.confirmedSessions = Array.from(confirmedSessions.getArray())
                this.populateSessionLists()
            })
    }

    private populateSessionLists() {
        const currentTime = this.utilsService.getCurrentTimestamp()
        let localList = []
        let localListPast = []
        for (let session of this.confirmedSessions) {
            if (
                !this.utilsService.hasSessionEnded(
                    session.sessionTime,
                    session.duration,
                    currentTime,
                )
            ) {
                if (localList.length === 0) {
                    localList.push({
                        dateLabel: this.userDateFormattingService.format(
                            session.sessionTime,
                            'ddd M/D',
                        ),
                        sessions: [session],
                    })
                } else {
                    const tempLabel = this.userDateFormattingService.format(
                        session.sessionTime,
                        'ddd M/D',
                    )
                    if (localList[localList.length - 1].dateLabel === tempLabel) {
                        localList[localList.length - 1].sessions.push(session)
                    } else {
                        localList.push({
                            dateLabel: tempLabel,
                            sessions: [session],
                        })
                    }
                }
            } else {
                if (localListPast.length === 0) {
                    localListPast.push({
                        dateLabel: this.userDateFormattingService.format(
                            session.sessionTime,
                            'ddd M/D',
                        ),
                        sessions: [session],
                    })
                } else {
                    const tempLabel = this.userDateFormattingService.format(
                        session.sessionTime,
                        'ddd M/D',
                    )
                    if (localListPast[localListPast.length - 1].dateLabel === tempLabel) {
                        localListPast[localListPast.length - 1].sessions.push(session)
                    } else {
                        localListPast.push({
                            dateLabel: tempLabel,
                            sessions: [session],
                        })
                    }
                }
            }
        }

        this.sessionList = [...localList]
        this.sessionListPast = [...localListPast.reverse()]
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null)
        this.ngUnsubscribe.complete()
    }
}
